import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';

function Currency({ value, ...props }) {
  return (
    <FormattedNumber
      value={value / 100}
      // eslint-disable-next-line react/style-prop-object
      style={'currency'}
      currency={'USD'}
      currencyDisplay={'symbol'}
      {...props}
    />
  );
}

Currency.propTypes = {
  value: PropTypes.any.isRequired
};

export default Currency;
